import type { ComponentProps } from 'react';

const CashlessHospital = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_670_163758)">
        <path
          opacity="0.75"
          d="M26.7658 20.1435L25.6487 19.6957C26.4661 17.649 26.5587 15.3841 25.9109 13.2775C25.2632 11.1708 23.9141 9.34923 22.0879 8.11535L22.762 7.11621C24.8161 8.50453 26.3333 10.5538 27.0617 12.9237C27.79 15.2935 27.6856 17.8412 26.7658 20.1435Z"
          fill="#85CFC9"
        />
        <path
          opacity="0.75"
          d="M16.1407 26.9495C13.9616 26.955 11.8315 26.3033 10.0285 25.0794C8.22558 23.8556 6.83359 22.1164 6.03434 20.0892C5.23509 18.062 5.06574 15.8408 5.5484 13.7158C6.03106 11.5909 7.1433 9.6608 8.73986 8.17773L9.56084 9.0589C8.02888 10.4922 7.00605 12.386 6.64743 14.453C6.2888 16.5201 6.61395 18.6477 7.57356 20.5133C8.53317 22.3789 10.0749 23.8807 11.965 24.7911C13.8552 25.7014 15.9906 25.9707 18.0475 25.5579L18.2883 26.7377C17.5813 26.8797 16.8618 26.9507 16.1407 26.9495Z"
          fill="#85CFC9"
        />
        <path
          d="M25.9631 29.0322C25.7804 29.0326 25.6001 28.9913 25.4357 28.9117C25.2714 28.832 25.1273 28.716 25.0145 28.5724L20.5533 22.8761C20.3563 22.6229 20.2679 22.3018 20.3077 21.9835C20.3474 21.6652 20.5119 21.3757 20.7651 21.1787C21.0183 20.9818 21.3394 20.8934 21.6577 20.9331C21.976 20.9729 22.2655 21.1374 22.4625 21.3906L26.9237 27.0869C27.0627 27.2647 27.1489 27.4779 27.1725 27.7023C27.1962 27.9267 27.1563 28.1532 27.0574 28.356C26.9585 28.5589 26.8046 28.7298 26.6132 28.8494C26.4219 28.9689 26.2007 29.0323 25.9751 29.0322H25.9631Z"
          fill="#355D60"
        />
        <path
          d="M19.8159 23.5672L21.0847 25.291C21.0847 25.291 23.4923 24.1498 24.6046 22.1226L23.1721 20.4614C23.1721 20.4614 22.0598 22.8401 19.8159 23.5672Z"
          fill="#5BAFA9"
        />
        <path
          d="M11.5308 22.5126L11.2202 5.82097L21.3175 5.52002L21.6257 22.0624L16.9382 23.8825L11.5308 22.5126Z"
          fill="#E3E0DB"
        />
        <path
          d="M12.7651 14.796L12.8157 16.5391L14.3325 16.515L14.3156 14.7695L12.7651 14.796Z"
          fill="#B5ADA2"
        />
        <path
          d="M15.7988 14.7384L15.8494 16.4815L17.3637 16.4574L17.3493 14.7144L15.7988 14.7384Z"
          fill="#B5ADA2"
        />
        <path
          d="M18.7769 14.6828L18.8274 16.4258L20.3418 16.4018L20.3273 14.6587L18.7769 14.6828Z"
          fill="#B5ADA2"
        />
        <path
          d="M12.7466 18.1305L12.7971 19.8736L14.3115 19.8495L14.2971 18.1064L12.7466 18.1305Z"
          fill="#B5ADA2"
        />
        <path
          d="M15.7793 18.0729L15.8274 19.816L17.3442 19.7919L17.3298 18.0488L15.7793 18.0729Z"
          fill="#B5ADA2"
        />
        <path
          d="M18.7583 18.0177L18.8065 19.7608L20.3232 19.7367L20.3088 17.9937L18.7583 18.0177Z"
          fill="#B5ADA2"
        />
        <path
          d="M16.8361 7.34656L15.6323 7.35791L15.6821 12.6423L16.8859 12.6309L16.8361 7.34656Z"
          fill="#E06257"
        />
        <path
          d="M18.8989 9.28669L13.5181 9.31299L13.5239 10.5168L18.9048 10.4905L18.8989 9.28669Z"
          fill="#E06257"
        />
        <path
          d="M21.3909 9.8005L21.4294 11.611C22.5945 12.8984 23.233 14.5767 23.2182 16.313C23.2182 18.1768 22.4778 19.9643 21.1599 21.2823C19.8419 22.6002 18.0544 23.3406 16.1906 23.3406C14.3267 23.3406 12.5392 22.6002 11.2212 21.2823C9.9033 19.9643 9.16289 18.1768 9.16289 16.313C9.17214 15.3689 9.36839 14.436 9.74031 13.5682C10.1122 12.7004 10.6524 11.9149 11.3297 11.2571L11.2912 9.57178C9.8785 10.599 8.82365 12.0435 8.27519 13.7018C7.72674 15.3601 7.71233 17.1487 8.23398 18.8156C8.75563 20.4826 9.78706 21.9439 11.183 22.9937C12.5789 24.0436 14.269 24.6291 16.0153 24.6677C17.7615 24.7064 19.4759 24.1963 20.9169 23.2093C22.3579 22.2223 23.4531 20.808 24.048 19.1658C24.6429 17.5236 24.7077 15.7361 24.2332 14.0552C23.7586 12.3742 22.7688 10.8844 21.4029 9.79568L21.3909 9.8005Z"
          fill="#85CFC9"
        />
        <path
          opacity="0.5"
          d="M16.49 30C13.4024 29.9978 10.4021 28.975 7.95618 27.0907C5.51022 25.2064 3.75576 22.5664 2.96588 19.5815C2.176 16.5967 2.395 13.4345 3.58881 10.587C4.78261 7.73951 6.88424 5.36656 9.56661 3.83745C12.249 2.30834 15.3616 1.70886 18.42 2.1323C21.4784 2.55575 24.3111 3.97837 26.4771 6.17875C28.6431 8.37912 30.021 11.2338 30.3962 14.2985C30.7715 17.3632 30.123 20.466 28.5519 23.124L27.5191 22.5101C29.0496 19.911 29.6117 16.8544 29.1059 13.8808C28.6002 10.9073 27.0591 8.2084 24.7553 6.26152C22.4515 4.31464 19.5335 3.2452 16.5172 3.24236C13.501 3.23951 10.5809 4.30344 8.27343 6.24598C5.96597 8.18851 4.41983 10.8845 3.90845 13.8571C3.39707 16.8297 3.9534 19.8873 5.47906 22.4893C7.00472 25.0912 9.40139 27.0698 12.2452 28.0751C15.089 29.0804 18.1967 29.0476 21.0186 27.9825L21.4448 29.1092C19.8607 29.7035 18.1819 30.0054 16.49 30Z"
          fill="#85CFC9"
        />
      </g>
      <defs>
        <clipPath id="clip0_670_163758">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CashlessHospital;
